import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrademark = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.531 15.6351C15.9127 16.1867 15.5179 16.94 14.8471 16.94V16.94C14.5701 16.94 14.3113 16.8021 14.1569 16.5722L12.024 13.398H10.694V16.093C10.694 16.5608 10.3148 16.94 9.847 16.94V16.94C9.37921 16.94 9 16.5608 9 16.093V8C9 7.44771 9.44772 7 10 7H12.668C13.8067 7 14.656 7.294 15.216 7.882C15.7853 8.47 16.07 9.24933 16.07 10.22C16.07 11.8067 15.342 12.8053 13.886 13.216V13.258L15.531 15.6351ZM10.694 8.512V11.872H12.304C12.9573 11.872 13.4567 11.7227 13.802 11.424C14.1473 11.116 14.32 10.7053 14.32 10.192C14.32 9.66 14.152 9.24933 13.816 8.96C13.4893 8.66133 13.0227 8.512 12.416 8.512H10.694Z",
		fill: "currentColor"
	})]
});
export default SvgTrademark;
